export type MenuTranslation = {
  items: {
    ATTEMPTS: string;
    DASHBOARD: string;
    DEV_PATTERNS: string;
    DICTIONARIES: string;
    PATHS: string;
    PROCESSES: string;
    QUESTION_BANK: string;
    QUESTION_STATISTICS: string;
    SETTINGS: string;
    SURVEYS: string;
    TESTS: string;
  };
  sections: {
    DEVELOPER: string;
    MODULES: string;
    OVERVIEW: string;
    SYSTEM: string;
  };
};

export const menuTranslation: MenuTranslation = {
  items: {
    ATTEMPTS: 'Attempts',
    DASHBOARD: 'Dashboard',
    DEV_PATTERNS: 'UI patterns',
    DICTIONARIES: 'Dictionaries',
    PATHS: 'Paths',
    PROCESSES: 'Processes',
    QUESTION_BANK: 'Question bank',
    QUESTION_STATISTICS: 'Question performance',
    SETTINGS: 'Settings',
    SURVEYS: 'Surveys',
    TESTS: 'Tests',
  },
  sections: {
    DEVELOPER: 'Developer',
    MODULES: 'Modules',
    OVERVIEW: 'Overview',
    SYSTEM: 'System',
  },
};
